import Image from 'next/image';
import React from 'react';

const FooterFeature = ({ icon, title, description }) => {
    return (
        <div className='flex flex-col items-center justify-center text-center'>
            <div className='block sm:mb-6 mb-3'>
                <Image
                    src={icon}
                    width={60}
                    height={60}
                    className="object-contain"
                    alt={title}
                />
            </div>
            <span className='text-themeBlack text-lg font-medium leading-normal sm:mb-4 mb-1'>{title}</span>
            <span className='text-themeBlack text-opacity-50 text-size-13 font-normal leading-5'>{description}</span>
        </div>
    );
};

export default FooterFeature;
